export { default } from './ImageCollage';
